var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10.714,
    viewBox: "0 0 16 10.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14271",
    "data-name": "Group 14271",
    transform: "translate(-1212.575 -360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14270",
    "data-name": "Group 14270",
    transform: "translate(1212.575 360)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13402",
    "data-name": "Path 13402",
    d: "M49.626,18.2H41.358a.659.659,0,0,0-.658.658.67.67,0,0,0,.658.658h8.251a.658.658,0,0,0,.017-1.316Z",
    transform: "translate(-34.267 -18.2)",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13403",
    "data-name": "Path 13403",
    d: "M47.567,36.8H41.358a.659.659,0,0,0-.658.658.67.67,0,0,0,.658.658h6.209a.659.659,0,0,0,.658-.658A.67.67,0,0,0,47.567,36.8Z",
    transform: "translate(-34.267 -33.662)",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13404",
    "data-name": "Path 13404",
    d: "M45.509,55.3H41.358a.659.659,0,0,0-.658.658.67.67,0,0,0,.658.658h4.151a.658.658,0,0,0,0-1.316Z",
    transform: "translate(-34.267 -49.04)",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13405",
    "data-name": "Path 13405",
    d: "M43.45,73.9H41.358a.659.659,0,0,0-.658.658.67.67,0,0,0,.658.658H43.45a.658.658,0,0,0,0-1.316Z",
    transform: "translate(-34.267 -64.502)",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13406",
    "data-name": "Path 13406",
    d: "M5.633,18.465a.683.683,0,0,0-.945,0L2.765,20.388a.668.668,0,0,0,.945.945L4.5,20.54v7.779a.659.659,0,0,0,.658.658.67.67,0,0,0,.658-.658V20.54l.793.793a.652.652,0,0,0,.945,0,.683.683,0,0,0,0-.945Z",
    transform: "translate(-2.575 -18.262)",
    fill: "#868a97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriority);
export default __webpack_public_path__ + "static/media/priority.8379415c867e62041c0860886fa35617.svg";
export { ForwardRef as ReactComponent };